import type { BaseSelectProps } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { FC } from "react";
import toast from "react-hot-toast";
import type { BrandKitStyle } from "../brand-kit/server/brand-kit-service";
import { isStandardBrandKitStyle } from "../brand-kit/server/brand-kit-service";

interface VisualStyleSelectProps extends Omit<BaseSelectProps, "onChange"> {
  onChange: (style: BrandKitStyle) => void;
  brandStyle: BrandKitStyle;
}

export const VisualStyleSelect: FC<VisualStyleSelectProps> = ({
  onChange,
  brandStyle,
  ...props
}) => {
  const label = "Image style";

  return (
    <FormControl sx={{ width: "13em" }}>
      <InputLabel htmlFor="visual-style-select">{label}</InputLabel>
      <Select
        id="visual-style-select"
        value={brandStyle.value ?? "bold"}
        onChange={(e) => {
          const val = e.target.value as string;

          if (!isStandardBrandKitStyle(val)) {
            toast.error("Invalid Visual Style");
            return;
          }
          onChange({ type: "standard", value: val });
        }}
        label={label}
        inputProps={{
          "aria-label": label,
        }}
        {...props}
      >
        <MenuItem value="bold">Bold</MenuItem>
        <MenuItem value="sophisticated">Sophisticated</MenuItem>
        <MenuItem value="organic">Organic</MenuItem>
        <MenuItem value="formal">Formal</MenuItem>
        <MenuItem value="minimalist">Minimalist</MenuItem>
      </Select>
    </FormControl>
  );
};
